import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { deleteDriverCommission } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

const DriverCommissionDeleteButton = ({ driverCommissionId, dispatchDeleteDriverCommission }) => {

  const [showModel, setShowModel] = useState(false);

  const onClickDelete = () => dispatchDeleteDriverCommission(driverCommissionId);

  const openModal = () => setShowModel(true);

  const closeModal = () => setShowModel(false);

  return (
    <>
    <ConfirmationModal
      show={showModel}
      onClickConfirm={onClickDelete}
      onClickCancel={closeModal}
    />
    <Button color="danger" onClick={openModal}>
      <i className="fa fa-trash-o" /> Eliminar
    </Button>
    </>
  );
};

DriverCommissionDeleteButton.propTypes = {
  driverCommissionId: PropTypes.number.isRequired,
  dispatchDeleteDriverCommission: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  dispatchDeleteDriverCommission: deleteDriverCommission
};

export default connect(null, mapDispatchToProps)(DriverCommissionDeleteButton);